import { render } from "./Loader.vue?vue&type=template&id=4ece3096"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=4ece3096&lang=css"
script.render = render

export default script